import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useActiveBar } from "../ActiveBarContext";
import { useAuth } from "../../AuthContext";
import { unlinkCharity } from "../shared/unlinkCharity";

export default function LinkedBars() {
  const { myBars } = useActiveBar();
  const { refreshUserBars } = useAuth();
  const [busyId, setBusyId] = useState(null);
  const [message, setMessage] = useState("");

  // Always show the latest links (the other side may have changed them).
  useEffect(() => {
    refreshUserBars().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unlink = async (bar) => {
    const ok = window.confirm(
      `Unlink ${bar.name || "this bar"}?\n\n` +
        "Your charity will no longer be shown as running gaming there. " +
        "The gaming info and the events your charity posted at this bar will be removed. " +
        "This can't be undone, but you can claim the bar again later."
    );
    if (!ok) return;
    setBusyId(bar.id);
    setMessage("");
    try {
      const removed = await unlinkCharity(bar);
      await refreshUserBars();
      setMessage(`Unlinked ${bar.name || "the bar"}${removed ? ` and removed ${removed} event${removed === 1 ? "" : "s"}` : ""}.`);
    } catch (e) {
      setMessage(`Couldn't unlink it: ${e.message}`);
    }
    setBusyId(null);
  };

  return (
    <div style={{ color: "#fff" }}>
      <h2 style={{ marginBottom: "10px" }}>Linked Bars</h2>
      <p style={{ marginBottom: "20px", color: "#B8B0C8" }}>
        These are the bars your charity is currently partnered with for gaming.
      </p>
      {message && <p style={{ color: message.startsWith("Couldn't") ? "#F472B6" : "#4ADE80", marginBottom: "16px" }}>{message}</p>}

      {myBars.length === 0 ? (
        <div
          style={{
            background: "#0D0B1A",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "12px",
            padding: "24px",
            maxWidth: "500px",
          }}
        >
          <p style={{ marginBottom: "16px" }}>
            You haven't linked any bars yet.
          </p>
          <Link
            to="/charity/claim-bar"
            style={{
              display: "inline-block",
              background: "linear-gradient(90deg, #6D28D9, #A855F7)",
              padding: "10px 18px",
              borderRadius: "8px",
              color: "#fff",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            Search and Claim a Bar
          </Link>
        </div>
      ) : (
        myBars.map((bar) => (
          <div
            key={bar.id}
            style={{
              background: "#0D0B1A",
              border: "1px solid rgba(168,85,247,0.4)",
              borderRadius: "12px",
              padding: "20px",
              marginBottom: "14px",
            }}
          >
            <h3 style={{ margin: "0 0 6px" }}>{bar.name || "Unnamed Bar"}</h3>
            <p style={{ margin: 0, color: "#B8B0C8", fontSize: "16px" }}>
              {bar.address || "No address on file"}
            </p>
            <p style={{ margin: "8px 0 0", fontSize: "16px", color: bar.ownerId ? "#4ADE80" : "#F472B6" }}>
              {bar.ownerId ? "Owner claimed" : "Waiting on an owner to claim this bar"}
            </p>
            <button
              type="button"
              onClick={() => unlink(bar)}
              disabled={busyId === bar.id}
              style={{
                marginTop: "14px",
                minHeight: "44px",
                padding: "0 16px",
                borderRadius: "8px",
                border: "1px solid #F472B6",
                background: "transparent",
                color: "#F472B6",
                fontWeight: 600,
                fontSize: "15px",
                cursor: "pointer",
              }}
            >
              {busyId === bar.id ? "Unlinking..." : "Unlink this bar"}
            </button>
          </div>
        ))
      )}
    </div>
  );
}